import { DefaultTheme } from "styled-components";

const theme: DefaultTheme = {};

export default theme;
